import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        classifiers: '<'
    },
    template: `
        <list-empty list="vm.requiredCompetences" show-add-message="true"></list-empty>
        <table class="data01" dt-options="vm.DATATABLES" ng-if="vm.requiredCompetences.length > 0">
            <thead>
            <tr>
                <th>{{ 'user.Competence name' | translate }}</th>
                <th>{{ 'user.Competence type' | translate }}</th>
                <th>&nbsp;</th>
            </tr>
            </thead>
            <tbody>
            <tr class="subheading03">
                <td colspan="4">{{ 'user.Competences' | translate }}</td>
            </tr>
            <tr ng-repeat="(index, requiredCompetence) in vm.requiredCompetences">
                <td><a ui-sref="authorized.user.competence.competence.view({ id: requiredCompetence.competency.id })">{{ requiredCompetence.competency.name }}</a></td>
                <td>{{ vm.USER_COMPETENCE_REQUIREMENT_COMPETENCE_TYPE_ENUM.LABELS[requiredCompetence.type] }}</td>
                <td class="actions">
                    <a class="btn edit" ng-click="vm.editCompetence(index, requiredCompetence)">{{ 'general.Edit' | translate }}</a>
                </td>
            </tr>
            </tbody>
        </table>
`
})
export default class {
    constructor (ModalService, $scope, USER_COMPETENCE_REQUIREMENT_COMPETENCE_TYPE_ENUM) {
        this.ModalService = ModalService;
        this.parentScope = $scope.$parent;
        this.USER_COMPETENCE_REQUIREMENT_COMPETENCE_TYPE_ENUM = USER_COMPETENCE_REQUIREMENT_COMPETENCE_TYPE_ENUM;
    }

    $onInit () {
        const { parentScope } = this;
        this.requiredCompetences = parentScope.vm.requiredCompetences[parentScope.index];
    }


    editCompetence (index, competence) {
        return this.ModalService.open({
            template: `<modals-competence-requirements-edit-competence drl-requirement-competence="vm.competence" on-close="vm.$uibModalInstance.dismiss()"
                on-update="vm.update(updatedRequirement)" class="wrapper" />`,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.competence = competence;
                this.update = (updatedRequirement) => {
                    return this.$uibModalInstance.close(updatedRequirement);
                };
            }
        }).then((updatedRequirement) => {
            this.requiredCompetences[index] = updatedRequirement;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/competence/requirements/competences/index.js